import axios from "axios";
import env from "../../../../../../config/env";
import "./index.css";
import toast from "react-hot-toast";
const Modal = ({ isOpen, onClose, children }) => {
  const BASE_URL = `${env.API_URL}/v1`;
  return (
    <>
      {isOpen && (
        <div className="modal-overlay" onClick={onClose}>
          <div
            className="modal-content-modal text-center"
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </div>
        </div>
      )}
    </>
  );
};

// Example usage in another component
const DeleteFileModal = ({ isModalOpen, justCloseIt, fileInfo, getLocationUsers }) => {
  const BASE_URL = `${env.API_URL}/v1`;
  const deleteTeamMember = async () => {
    try {
      const response = await axios.delete(`${BASE_URL}/user/team-member/${fileInfo._id}`);

      if (response.data.success) {
        toast.success("User deleted successfully");
        justCloseIt()
        getLocationUsers()
        return true;
      } else {
        toast.error(response.data.message);
        return false;
      }
    } catch (error) {
      console.error("Error deleting user:", error);
      alert("An error occurred while deleting the user. Please try again.");
      return false;
    }
  };


  return (
    <div>
      <Modal isOpen={isModalOpen}>
        <div className="scrollable-modal-content position-relative" >

          <p
            style={{
              position: "absolute",
              right: 12,
              width: "12px",
              top: "10px",
              height: "12px",
              cursor: "pointer",
            }}
            onClick={justCloseIt}
          >
            X
          </p>


          <div style={{ marginBottom: "20px" }}>
            <span className="modalTextBold" >Delete Team Member</span>
          </div>

          <p className="modalText" >
            Are you sure you want to delete this team member<br />
            This action cannot be undone.
          </p>

          <div className="modalBtnGroup">
            <button type="submit" className="agreeBtn" onClick={deleteTeamMember}>
              Yes, delete team member
            </button>

            <button className="disagreeBtn" onClick={justCloseIt}>
              No, go back
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default DeleteFileModal;
